// src/contexts/tree.tsx
import { createContext } from "react";
import { jsx } from "react/jsx-runtime";
var LayoutContext = createContext({
  tree: { name: "Docs", children: [] }
});
function LayoutContextProvider({
  value,
  children
}) {
  return /* @__PURE__ */ jsx(LayoutContext.Provider, { value, children });
}

export {
  LayoutContext,
  LayoutContextProvider
};
